<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <draw-table></draw-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import drawTable from './DrawTable.vue'

  export default {
    name: 'draw',
    components: {drawTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/draw/Draw.vue